import { SubTopNavBarVariants } from "./SubTopNavBar.constants";

export const isDrawerVariant = (variant?: string) =>
  !!variant ? variant === SubTopNavBarVariants.Drawer : false;
